'use strict';

module.exports = {
  GUEST: 0,
  USER: 10,
  ADMIN: 50
};


// WEBPACK FOOTER //
// ./src/common/auth/AuthLevels.js